import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import MenuCM from "components/shared/menu";
import ProfileMenuCM from "components/profilemenu";
import FooterCM from "components/shared/footer";
import Container from "@mui/material/Container";
import Paper from "@mui/material/Paper";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import CardContent from "@mui/material/CardContent";
import PaginationCM from "components/shared/Pagination";
import {
  StyledCardContent,
  StyledCard,
  StyledTypography,
  StyledNewMessage,
  StyledCardActions,
  StyledContainer,
  StyledStatus,
  StyledIcondiv,
  StyledStatusFactor,
  ImageContainer,
} from "./Orders.style";
import ContactCM from "components/contactus";
import { getOrdersRequest } from "api/requests";
import useHttp from "hooks/use-http";
import { PAGINATION_LIMIT_10 } from "constants";
import LoadingCM from "components/shared/Loading";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import Button from "@mui/material/Button";
import spliter from "helper/digit-spliter";
import { IMG_BASE_URL } from "constants";
import {Helmet} from "react-helmet";

export default function Orders() {
  const { request, loading } = useHttp();
  const [orders, setOrders] = useState({
    data: [],
    count: 0,
  });
  const [page, setPage] = useState(1);

  const getOrders = useCallback(async () => {
    const res = await request({
      url: getOrdersRequest,
      values: {
        skip: (page - 1) * PAGINATION_LIMIT_10,
        limit: PAGINATION_LIMIT_10,
        type: "message",
      },
    });

    let transformedData = res.data.map((items) => ({
      id: items.id,
      payment_status: items?.payment_status,
      date: items?.created_at?.jdate.split(" ")[0],
      order_number: items?.order_number,
      total_price: items?.total_price,
      order_contents: items?.order_contents,
    }));

    setOrders({
      data: transformedData,
      count: res.count,
    });
  }, [page, request]);

  useEffect(() => {
    getOrders();
  }, [page, getOrders]);

  return (
    <>
      {loading && <LoadingCM />}
      <Helmet>
        <title>سفارشات من - مبلمان ویول</title>
        <meta name="product_id" content={""} />
        <meta name="product_name" content={""} />
        <meta name="product_price" content={""} />
        <meta name="product_old_price" content={""} />
        <meta name="availability" content={""} />
        <meta property="og:image" content={""} />
      </Helmet>
      <MenuCM Background pageTitle="سفارشات من" />
      <Container>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={3} lg={3}>
            <ProfileMenuCM />
          </Grid>
          <Grid item xs={12} sm={12} md={9} lg={9} mb={10}>
            <Paper p={2}>
              <StyledCardContent>
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: "21px",
                  }}
                >
                  سفارشات من
                </Typography>
              </StyledCardContent>
              <CardContent>
                {orders.count < 1 ? (
                  <div style={{ textAlign: "center", padding: "28px" }}>
                    سفارشی یافت نشد
                  </div>
                ) : (
                  <StyledContainer pb={2} spacing={2} mt={2}>
                    {orders.data.map((items, index) => (
                      <StyledCard key={"card" + index}>
                        <CardContent>
                          {items.payment_status == "failed" ? (
                            <StyledStatus>
                              <StyledIcondiv>
                                <HighlightOffIcon style={{ color: "red" }} />
                              </StyledIcondiv>
                              <span>ناموفق</span>
                            </StyledStatus>
                          ) : (
                            <StyledStatus>
                              <StyledIcondiv>
                                <CheckCircleOutlineIcon
                                  style={{ color: "green" }}
                                />
                              </StyledIcondiv>
                              <span>موفق</span>
                            </StyledStatus>
                          )}
                          <StyledStatusFactor>
                            <StyledTypography variant="body2">
                              <span>شماره سفارش : </span>
                              {items.order_number}
                            </StyledTypography>
                            <StyledTypography variant="body2">
                              <span>مبلغ : </span>
                              {spliter(items.total_price)} تومان
                            </StyledTypography>
                            <StyledTypography variant="body2">
                              <span>تاریخ : </span>
                              {items.date}
                            </StyledTypography>
                          </StyledStatusFactor>
                          <ImageContainer>
                            {items.order_contents.map((item, index) => (
                              <div key={index}>
                                <img
                                  src={
                                    IMG_BASE_URL +
                                    item?.product_color?.product?.image
                                  }
                                  alt={item?.product_color?.product?.title}
                                  title={item?.product_color?.product?.title}
                                />
                                <span
                                  style={{
                                    background: item?.product_color?.color_code,
                                  }}
                                ></span>
                              </div>
                            ))}
                          </ImageContainer>
                        </CardContent>
                        <StyledCardActions style={{ direction: "ltr" }}>
                          <Link to={`/order/${items.id}`} key={"list" + index}>
                            <Button size="small">
                              <KeyboardArrowLeftIcon /> مشاهده فاکتور
                            </Button>
                          </Link>
                          {/* <Typography
                            sx={{ fontSize: 14 }}
                            color="text.secondary"
                            gutterBottom
                          >
                            {items.date}
                          </Typography> */}
                        </StyledCardActions>
                      </StyledCard>
                    ))}
                    <Grid container my={2} spacing={1}>
                      <Grid item xs={12}>
                        <PaginationCM
                          handleChange={(e, val) => setPage(val)}
                          page={page}
                          limit={PAGINATION_LIMIT_10}
                          count={orders.count}
                        />
                      </Grid>
                    </Grid>
                  </StyledContainer>
                )}
              </CardContent>
            </Paper>
          </Grid>
        </Grid>
      </Container>
      <ContactCM All />
      <FooterCM />
    </>
  );
}
